// extracted by mini-css-extract-plugin
module.exports = {"default":"AuthorPostGrid--default--hrUJs"};